import React from 'react';
import AppRoutes from './components/AppRoutes';
import './styles/App.css';
import { AuthProvider } from './context/AuthContext';

/**
 * @file App.tsx
 * @brief Hauptkomponente der Anwendung, die das Routing und die globale Themenverwaltung konfiguriert.
 *
 * Diese Komponente ist der Einstiegspunkt der React-Anwendung. Sie definiert die Routen für verschiedene Seiten
 * und wendet das gespeicherte oder System-Theme auf den Body an.
 *
 * @returns {JSX.Element} Das gerenderte React-Element, das die Anwendungsstruktur und Routen enthält.
 */
const App = () => {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
};

export default App;
